export const customPatterns = { 
    // 'S': { pattern: new RegExp('[a-zA-ZñÑáéíóúÁÉÍÓÚ \ ]')},
    'N': { pattern: new RegExp('[0-9.]')},
    'S': { pattern: new RegExp('\[a-zA-ZñÑáéíóúÁÉÍÓÚ\´\\s\]')},
    'E': { pattern: new RegExp('\[a-zA-ZñÑáéíóúÁÉÍÓÚ&0-9\´\\s\]')},
    'W': { pattern: new RegExp('[a-zA-Z0-9.:/-]')}
};

export const emailPattern = /^([a-zA-Z]|[0-9]+[a-zA-Z]+)([a-zA-Z0-9.a-zA-Z0-9.!#$%&'*+-/=?^_`{|}~])*@[a-zA-Z0-9\-]+\.[a-zA-Z]{2,}/